import React from "react"
const MyLoadingComponent = ({ isLoading, error }) => {
    if (isLoading) {
        return (
            <div
                style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    marginTop: "-50px",
                    marginLeft: "-50px"
                }}
            >
                <video
                    autoPlay
                    muted
                    style={{
                        width: "100px",
                        height: "100px"
                    }}
                    loop
                    poster="https://dn-st.teambition.net/web/release/images/loading-poster.7b3b7172.png"
                >
                    <source
                        id="webmSource"
                        src="https://dn-st.teambition.net/web/release/videos/loading-video.85c26f52.webm"
                        type="video/webm"
                    />
                    <source
                        id="mp4Source"
                        src="https://dn-st.teambition.net/web/release/videos/loading-video.4ced66f6.mp4"
                        type="video/mp4"
                    />
                </video>
            </div>
        )
    } else if (error) {
        return <div>Sorry, there was a problem loading the page.</div>
    } else {
        return null
    }
}

export default MyLoadingComponent
